import createSurveyFaceRecording from './createSurveyFaceRecording'
import uploadSurveyCameraRecording from './uploadSurveyCameraRecording'

export default function createSurveyFaceRecordingManager({ surveyCode, responseId }) {
  let activeRecorder = null
  const pendingUploads = new Set()
  const blobsByAdvertisement = new Map()

  const upload = async (exposure, recording) => {
    const uploaded = await uploadSurveyCameraRecording({
      surveyCode,
      responseId,
      questionNumber: exposure.advertisement_number,
      stepId: `ad_${exposure.advertisement_id}`,
      blob: recording.blob,
      extension: recording.extension,
    })
    exposure.camera_status = 'uploaded'
    exposure.camera_recording = { ...uploaded, duration_ms: recording.durationMs }
    delete exposure.camera_error
  }

  return {
    prepare() {
      if (activeRecorder) activeRecorder.abort()
      activeRecorder = createSurveyFaceRecording()
    },
    start() {
      if (!activeRecorder) throw new Error('Camera recording is not ready')
      activeRecorder.start()
    },
    finish(exposure) {
      const recorder = activeRecorder
      activeRecorder = null
      if (!recorder) {
        exposure.camera_status = 'failed'
        exposure.camera_error = 'Camera recording was not prepared'
        return
      }
      exposure.camera_status = 'processing'
      const task = recorder.stop().then(async (recording) => {
        blobsByAdvertisement.set(exposure.advertisement_id, recording)
        await upload(exposure, recording)
      }).catch((error) => {
        exposure.camera_status = 'failed'
        exposure.camera_error = error.message || String(error)
      })
      pendingUploads.add(task)
      task.finally(() => pendingUploads.delete(task))
    },
    async ensureUploaded(exposures) {
      await Promise.all([...pendingUploads])
      for (const exposure of exposures) {
        if (exposure.camera_status === 'uploaded' && exposure.camera_recording?.storage_path) continue
        const recording = blobsByAdvertisement.get(exposure.advertisement_id)
        if (!recording) throw new Error(`Camera recording is missing for ${exposure.advertisement_id}`)
        await upload(exposure, recording)
      }
    },
    abort() {
      if (activeRecorder) activeRecorder.abort()
      activeRecorder = null
    },
  }
}
